

const data = {
    NODE_ENV: process.env.REACT_APP_NODE_ENV || 'v1',
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'backendkpi.naturabo.net',
    BACKEND_URL_PORT: process.env.REACT_APP_BACKEND_URL_PORT || '',
    BACKEND_URL_PROTOCOL: process.env.REACT_APP_BACKEND_URL_PROTOCOL||'https',
    // PUBLIC_URL:process.env.REACT_APP_PUBLIC_URL||'http://localhost:3016',
    
}

export default data;